import {Component, Input, OnInit} from '@angular/core';
import {Customer} from '../../../shared/models/customer.class';
import {InviteUser} from '../../../shared/models/invite/invite-user.class';
import {SportsApiService} from '../../../sports-api.service';
import {FormManagementService} from '../../../shared/services/form-management.service';
import {NotificationService} from '../../../shared/services/notification-service/notification.service';
import {DialogConfirmationComponent} from '../../../shared/components/dialogs/dialog-confirmation/dialog-confirmation.component';
import {DialogService} from '../../../shared/services/dialog-service/dialog.service';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'app-customer-invite-list',
    templateUrl: './customer-invite-list.component.html',
    styleUrls: ['./customer-invite-list.component.css'],
    standalone: false
})
export class CustomerInviteListComponent implements OnInit {
    @Input() customer: Customer;
    error = false;
    errorMessage = null;

    formId = 'inviteUserForm';
    inviteUser: InviteUser;
    inviteForm = false;
    protected sendNotification = true;
    protected guestManagerURL = '';

    constructor(private sportsApiService: SportsApiService,
                private formManagementService: FormManagementService,
                private notificationService: NotificationService,
                private dialogService: DialogService) {
    }

    ngOnInit() {
        if (!this.customer.inviteOrganisationId) {
            this.inviteUser = new InviteUser(null, null);
            return;
        }

        this.guestManagerURL = environment.GUEST_MANAGER_2_URL;

        this.getInviteUsers();
    }

    private getInviteUsers(): void {
        this.sportsApiService.getInviteUsers(this.customer.id).subscribe({
            next: (users: InviteUser[]) => {
                this.customer.invite = {
                    users: users
                };
                const emailValue = users != null ? null : this.customer.email ?? null;
                this.inviteUser = new InviteUser(null, emailValue);
            },
            error: (error) => {
                this.notificationService.error(error.error.message);
            }
        });
    }

    public addInviteUser() {
        if (!this.isFormValid()) {
            return;
        }

        this.sportsApiService.addUserToInvite(this.customer.id, this.inviteUser.email, this.customer.language, this.sendNotification).subscribe({
            next: () => {
                this.getInviteUsers();
                this.notificationService.showTranslatedSuccessNotification('User', 'added');
            },
            error: (error) => {
                this.errorMessage = error.error.message;
            }
        });
    }

    public removeInviteUser(userId: string) {
        this.dialogService.createDialogComponent(DialogConfirmationComponent, {
            titleText: {key: 'Dialog.Delete_Invite_Account_Title'},
            bodyText: {key: 'Dialog.Delete_Invite_Account_Body'},
            cancelText: 'Dialog.Cancel',
            confirmText: 'Dialog.Ok'
        }, 'remove-invite-user');

        this.dialogService.emitDataSubject.subscribe(response => {
            if (!response.cancelled) {

                this.error = false;

                this.sportsApiService.removeUserFromInvite(this.customer.id, userId).subscribe({
                    next: () => {
                        this.customer.invite.users = this.customer.invite.users.filter(user => user.id !== userId);
                        this.notificationService.showTranslatedSuccessNotification('User', 'deleted');
                    },
                    error: (error) => {
                        this.error = error.error.message;
                    }
                });
            }
        });
    }

    public enableInvite(customer: Customer) {
        this.error = false;

        this.sportsApiService.createInviteOrganisation(customer.id).subscribe({
            next: () => {
                this.customer.inviteOrganisationId = 'tempId';
                this.customer.invite = {users: []};
                this.inviteUser.email = customer.email;
            },
            error: (error: any) => {
                this.error = error.error.message;
            }
        });
    }

    public isFormValid(): boolean {
        return this.inviteUser.email && this.formManagementService.validate(this.formId);
    }

    protected handleCheckboxChange(event: any): void {
        this.sendNotification = event.target.checked;
    }
}
